module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.fossil.fuel.cement.co2.emissions.d73d9812.png").toString();